
















































import {Vue, Component, Prop} from 'vue-property-decorator';
import TicketAttachment from "@/domainObjects/TicketAttachment";
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import TicketService from "@/services/TicketService";
import alertMixin from "@/mixins/alert-mixin";
import LoadingIndicator from "@/view/shared-components/LoadingIndicator.vue";
import UploadFile from "@/view/shared-components/UploadFile.vue";
import {mapGetters} from "vuex";

@Component({
    components: {UploadFile, LoadingIndicator},
    mixins: [alertMixin],
    computed: {
        ...mapGetters(['getGroups']),
    }
})
export default class HoldFileAttachments extends Vue {
    @Prop({required: true}) holdTicket!: HoldTicket;
    @Prop({required: true}) type!: String;

    private attachments:TicketAttachment[] = [];
    private holdTicketId:number = 0;
    private fileId:any = 0;
    private unsecureServerUrl: string = "";
    private uploading: boolean = false;
    private loadingAttachments: boolean = true;
    private dismissCountDown: number = 0;
    $_alertMixin_swalConfirm!: (heading: string | null, message: string | null, type: string | null) => Promise<boolean>;
    $_alertMixin_deleteSuccess!: () => void;

    mounted(){
        this.unsecureServerUrl = TicketService.getUnsecureServerUrl();
        this.holdTicketId = parseInt(this.$route.params['holdTicketId']);
        TicketService.getHoldAttachments(this.holdTicketId).then((response) => {
            for (let attachment of response.data) {
                let mappedAttachment:TicketAttachment = { attachmentId: attachment.attachmentId, attachmentName: attachment.attachmentName };
                this.attachments.push(mappedAttachment);
            }
            this.holdTicket.attachmentCount = this.attachments.length;
            this.loadingAttachments = false;
        }).catch((error)=>{

        });
    }
    uploadFile( formData, fileName ) {
            this.uploading = true;
            //Can only send MultipartFile and String objects when consuming multipart/form-data -> parse id String to int on backend
            formData.append("holdTicketId",this.holdTicketId+"");
            TicketService.saveHoldAttachment(formData).then((response) => {
                this.fileId = response.data;
                let file:TicketAttachment = {
                    attachmentId: this.fileId,
                    attachmentName: fileName
                };
                this.attachments.push(file);
                this.holdTicket.attachmentCount = this.attachments.length;
                this.uploading = false;
                this.dismissCountDown = 3;
            }).catch((error) =>{
                alert("Error Uploading File!");

                this.uploading = false;
            })
    }
    deleteFile( attachmentId, index ) {
        let self = this;
        this.$_alertMixin_swalConfirm('Delete Attachment?', 'This action cannot be undone', 'warning').then((value) => {
            if (value) {
                TicketService.deleteHoldAttachment(attachmentId).then((response) => {
                    if(response.data === 'success'){
                        self.$_alertMixin_deleteSuccess();
                        this.attachments.splice(index, 1);
                        this.holdTicket.attachmentCount = this.attachments.length;
                    }
                    else {
                        alert("ticket not saved! Unable to save the current ticket")
                    }
                }).catch((error) => {
                    alert("unable to delete file " + error)
                })
            }
        })
    }
}
